import {
  Consumer,
  Employee,
  Vehicle,
  Address
} from '../index';

declare var Object: any;
export interface TripManifestRecInterface {
  "id"?: string;
  "rt"?: boolean;
  "o"?: string;
  "d"?: string;
  "at"?: string;
  "t"?: string;
  "put"?: string;
  "dot"?: string;
  "st"?: string;
  "mu_v2"?: any;
  "mu1"?: number;
  "mu2"?: number;
  "mu3"?: number;
  "mu4"?: number;
  "mu5"?: number;
  "tr"?: number;
  "s"?: number;
  "b"?: string;
  "tId"?: string;
  "bn"?: string;
  "x"?: boolean;
  "dn"?: string;
  "ot"?: boolean;
  "na"?: boolean;
  "dubd"?: boolean;
  "rid"?: string;
  "dst"?: number;
  "dur"?: number;
  "c"?: number;
  "e"?: number;
  "v"?: number;
  "esc"?: number;
  "aid"?: number;
  consumer?: Consumer;
  employee?: Employee;
  vehicle?: Vehicle;
  escort?: Employee;
  address?: Address;
}

export class TripManifestRec implements TripManifestRecInterface {
  "id": string;
  "rt": boolean;
  "o": string;
  "d": string;
  "at": string;
  "t": string;
  "put": string;
  "dot": string;
  "st": string;
  "mu_v2": any;
  "mu1": number;
  "mu2": number;
  "mu3": number;
  "mu4": number;
  "mu5": number;
  "tr": number;
  "s": number;
  "b": string;
  "tId": string;
  "bn": string;
  "x": boolean;
  "dn": string;
  "ot": boolean;
  "na": boolean;
  "dubd": boolean;
  "rid": string;
  "dst": number;
  "dur": number;
  "c": number;
  "e": number;
  "v": number;
  "esc": number;
  "aid": number;
  consumer: Consumer;
  employee: Employee;
  vehicle: Vehicle;
  escort: Employee;
  address: Address;
  constructor(data?: TripManifestRecInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `TripManifestRec`.
   */
  public static getModelName() {
    return "TripManifestRec";
  }

  /**
  * This method creates an instance of TripManifestRec for dynamic purposes.
  **/
  public static factory(data: TripManifestRecInterface): TripManifestRec{
    return new TripManifestRec(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TripManifestRec',
      plural: 'TripManifestRecs',
      path: 'TripManifestRecs',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "rt": {
          name: 'rt',
          type: 'boolean',
          default: false
        },
        "o": {
          name: 'o',
          type: 'string'
        },
        "d": {
          name: 'd',
          type: 'string'
        },
        "at": {
          name: 'at',
          type: 'string'
        },
        "t": {
          name: 't',
          type: 'string'
        },
        "put": {
          name: 'put',
          type: 'string'
        },
        "dot": {
          name: 'dot',
          type: 'string'
        },
        "st": {
          name: 'st',
          type: 'string'
        },
        "mu_v2": {
          name: 'mu_v2',
          type: 'any'
        },
        "mu1": {
          name: 'mu1',
          type: 'number'
        },
        "mu2": {
          name: 'mu2',
          type: 'number'
        },
        "mu3": {
          name: 'mu3',
          type: 'number'
        },
        "mu4": {
          name: 'mu4',
          type: 'number'
        },
        "mu5": {
          name: 'mu5',
          type: 'number'
        },
        "tr": {
          name: 'tr',
          type: 'number',
          default: 0
        },
        "s": {
          name: 's',
          type: 'number',
          default: 0
        },
        "b": {
          name: 'b',
          type: 'string'
        },
        "tId": {
          name: 'tId',
          type: 'string'
        },
        "bn": {
          name: 'bn',
          type: 'string'
        },
        "x": {
          name: 'x',
          type: 'boolean'
        },
        "dn": {
          name: 'dn',
          type: 'string'
        },
        "ot": {
          name: 'ot',
          type: 'boolean'
        },
        "na": {
          name: 'na',
          type: 'boolean'
        },
        "dubd": {
          name: 'dubd',
          type: 'boolean'
        },
        "rid": {
          name: 'rid',
          type: 'string'
        },
        "dst": {
          name: 'dst',
          type: 'number'
        },
        "dur": {
          name: 'dur',
          type: 'number'
        },
        "c": {
          name: 'c',
          type: 'number'
        },
        "e": {
          name: 'e',
          type: 'number'
        },
        "v": {
          name: 'v',
          type: 'number'
        },
        "esc": {
          name: 'esc',
          type: 'number'
        },
        "aid": {
          name: 'aid',
          type: 'number'
        },
      },
      relations: {
        consumer: {
          name: 'consumer',
          type: 'Consumer',
          model: 'Consumer',
          relationType: 'belongsTo',
                  keyFrom: 'c',
          keyTo: 'id'
        },
        employee: {
          name: 'employee',
          type: 'Employee',
          model: 'Employee',
          relationType: 'belongsTo',
                  keyFrom: 'e',
          keyTo: 'id'
        },
        vehicle: {
          name: 'vehicle',
          type: 'Vehicle',
          model: 'Vehicle',
          relationType: 'belongsTo',
                  keyFrom: 'v',
          keyTo: 'id'
        },
        escort: {
          name: 'escort',
          type: 'Employee',
          model: 'Employee',
          relationType: 'belongsTo',
                  keyFrom: 'esc',
          keyTo: 'id'
        },
        address: {
          name: 'address',
          type: 'Address',
          model: 'Address',
          relationType: 'belongsTo',
                  keyFrom: 'aid',
          keyTo: 'id'
        },
      }
    }
  }
}
